import { RouterProvider } from 'react-router-dom';
import { router } from 'src/router';
import { memo } from 'react';

export const App = memo(() => {
    const composeRouter = router();
    return <RouterProvider router={composeRouter}/>;
});
